import { stat } from "fs";

const invoceSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_INVOCESEARCH: (state, invoceSearch) => {
      state.data = invoceSearch
    }
  }
}

export default invoceSearch



// WEBPACK FOOTER //
// ./src/store/modules/invoceSearch.js